import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UsePrivateCompanyLeadRelatedUsersProps<T> = {
  filters?: {
    search?: string
    page?: number
  }
  mapper?: (data: any) => T,
}

export const usePrivateCompanyLeadRelatedUsers = <T,>({
  filters: { search = '', page } = {},
  mapper = Mapper.default<T>(),
}: UsePrivateCompanyLeadRelatedUsersProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['privateCompanyLeadRelatedUsers', page, search],
    queryFn: () => {
      return privateAxios.get('/funnel/private_company_leads/related_users', {
        params: {
          search,
          page,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
